/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import Button   from 'components/Button/Button.react';
import stylesButton         from 'components/Button/Button.scss';
import ParseApp from 'lib/ParseApp';
import Parse    from 'parse';
import React    from 'react';

import PropTypes from 'prop-types';

export default class RunNowButton extends React.Component {
  constructor() {
    super();

    this.state = {
      progress: null,
      result: null
    };

    this.timeout = null;
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  handleClick() {
    this.setState({ progress: true });
    this.context.currentApp.runJob(this.props.job).then(() => {
      this.setState({ result: 'success' });
      this.timeout = setTimeout(() => this.setState({ progress: false, result: null }), 3000);
    }, () => {
      this.setState({ result: 'error' });
      this.timeout = setTimeout(() => this.setState({ progress: false, result: null }), 3000);
    });
  }

  render() {
    let { job, ...other } = this.props;
    let value = 'Run now';

    return (
      <a
        className={[stylesButton.tableButton, this.state.progress ? stylesButton.progress : null].join(' ')}
        href='javascript:;'
        onClick={this.handleClick.bind(this)}
        {...other}>
        <span>{value}</span>
      </a>
    );
  }
}

RunNowButton.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp),
};
